export default __webpack_public_path__ + "static/media/currency_rupee.f63fc7dd.svg";